import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { VideoModal, VideoModalConsumer, VideoModalProvider } from "../../Video";
import { OutsidePageWrapper } from "@parkschannel/ui";
import { PopularVideos, TvFrameFullPage } from "../../PopularVideos";
import { InitialPaginationContext, useButtonsAnalytics } from "../../../utils";
export const PopularVideosPage = (param)=>{
    let { initialPagination  } = param;
    useButtonsAnalytics();
    return /*#__PURE__*/ _jsx(VideoModalProvider, {
        children: /*#__PURE__*/ _jsxs(OutsidePageWrapper, {
            children: [
                /*#__PURE__*/ _jsx(TvFrameFullPage, {}),
                /*#__PURE__*/ _jsx(InitialPaginationContext.Provider, {
                    value: {
                        initialPagination
                    },
                    children: /*#__PURE__*/ _jsx(PopularVideos, {})
                }),
                /*#__PURE__*/ _jsx(VideoModalConsumer, {
                    children: (param)=>/*#__PURE__*/ {
                        let { selectedVideo , setSelectedVideo  } = param;
                        return _jsx(VideoModal, {
                            isOpen: !!selectedVideo,
                            setIsOpen: ()=>setSelectedVideo(null)
                        });
                    }
                })
            ]
        })
    });
};
